import styled, { css } from 'styled-components';


export const ConnectedAccountCard = styled.div`
  ${({ theme }) => css`
    all: unset;
    align-items: center;
    background-color: ${theme.v2.colors.brand.primaryLowLight};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 12px;
    text-align: left;
  `}
`;

export const ConnectedAccountName = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ConnectedAccountDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const ConnectedAccountInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
`;

export const AccountIconWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
`;


export const IconButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.brand.snappyBlue[90]};
    border-radius: 100%;
    border: 0px;
    cursor: pointer;
    display: flex;
    height: 100%;
    height: 42px;
    justify-content: center;
    margin: 0px 8px 0px auto;
    padding: 0px;
    width: 42px;
  `}
`;

export const Clickable = styled.button`
  ${({ theme }) => `
      align-items: center;
      all: unset;
      background-color: ${theme.v2.colors.brand.primaryLowLight};
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      flex-direction: row;
      gap: 12px;
      padding: 12px;
      text-align: left;
  `}
`;
